/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthAuthorizeResVo } from './OAuthAuthorizeResVo';
import {
    OAuthAuthorizeResVoFromJSON,
    OAuthAuthorizeResVoFromJSONTyped,
    OAuthAuthorizeResVoToJSON,
    OAuthAuthorizeResVoToJSONTyped,
} from './OAuthAuthorizeResVo';

/**
 * 
 * @export
 * @interface ResponseOAuthAuthorizeResVo
 */
export interface ResponseOAuthAuthorizeResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOAuthAuthorizeResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOAuthAuthorizeResVo
     */
    message?: string;
    /**
     * 
     * @type {OAuthAuthorizeResVo}
     * @memberof ResponseOAuthAuthorizeResVo
     */
    data?: OAuthAuthorizeResVo;
}

/**
 * Check if a given object implements the ResponseOAuthAuthorizeResVo interface.
 */
export function instanceOfResponseOAuthAuthorizeResVo(value: object): value is ResponseOAuthAuthorizeResVo {
    return true;
}

export function ResponseOAuthAuthorizeResVoFromJSON(json: any): ResponseOAuthAuthorizeResVo {
    return ResponseOAuthAuthorizeResVoFromJSONTyped(json, false);
}

export function ResponseOAuthAuthorizeResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOAuthAuthorizeResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OAuthAuthorizeResVoFromJSON(json['data']),
    };
}

export function ResponseOAuthAuthorizeResVoToJSON(json: any): ResponseOAuthAuthorizeResVo {
    return ResponseOAuthAuthorizeResVoToJSONTyped(json, false);
}

export function ResponseOAuthAuthorizeResVoToJSONTyped(value?: ResponseOAuthAuthorizeResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OAuthAuthorizeResVoToJSON(value['data']),
    };
}

